var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegativeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    stroke: "#AF4155"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.56975,
    cy: 3.56975,
    r: 0.714286,
    fill: "#AF4155"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.42522,
    cy: 3.56975,
    r: 0.714286,
    fill: "#AF4155"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 6.43088C3.81396 5.71662 5.36151 4.71667 6.79002 6.43088",
    stroke: "#AF4155",
    strokeWidth: 0.999955,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeIcon);
export default __webpack_public_path__ + "static/media/negative-icon.1b7ecc93de691a839371c66d032fa0b5.svg";
export { ForwardRef as ReactComponent };